export const TABLE_VARIANTS = [
    { id: 'basic', label: 'Basic', icon: 'fas fa-table' },
    { id: 'striped', label: 'Striped Rows', icon: 'fas fa-bars' },
    { id: 'bordered', label: 'Bordered Grid', icon: 'fas fa-border-all' },
    { id: 'compact', label: 'Compact', icon: 'fas fa-compress' },
    { id: 'card-rows', label: 'Card Rows', icon: 'fas fa-layer-group' },
    { id: 'dark-header', label: 'Dark Header', icon: 'fas fa-fill' },
    { id: 'status-badges', label: 'Status Badges', icon: 'fas fa-tag' },
    { id: 'minimal', label: 'Minimal', icon: 'fas fa-grip-lines' },
    { id: 'numbered', label: 'Numbered Rows', icon: 'fas fa-list-ol' },
    { id: 'hover-highlight', label: 'Hover Highlight', icon: 'fas fa-mouse-pointer' },
];
